export enum WhatRunAfterPassword {
  deepSync,
  main,
  statusDeepSync,
  tree
}
